import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LeadActions from '../../actions/lead';
import TranslationUtil from '../../utils/TranslationUtil';
import Phone from '../ListYourPropertyPage/Phone';
import { PHONE_VALIDATION_ERROR_MESSAGE } from '../../constants/common';

export const PhoneInputWrapper = (props) => {
    const {
        setPhoneCountryCode,
        setPhoneCountryCodeDigits,
        validatePhone,
        setPhoneNumber,
        setPhoneValidation,
        phoneInvalidText,
        phoneValidation,
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        phoneCountryLabel,
        phoneNumberLabel,
        countryTranslations
    } = props;

    const [shouldCheckValidation, setShouldCheckValidation] = useState(false);

    const validatePhoneData = (phoneData) => {
        const { raw, phoneCode, isValid } = phoneData;
        setPhoneValidation({
            isValid,
            error: isValid ? undefined : phoneInvalidText
        });
        if (isValid) {
            validatePhone(`+${phoneCode}${raw}`);
        }
    };

    const handlePhoneCountryCodeChange = (e, countryData) => {
        setShouldCheckValidation(true);
        setPhoneCountryCode(countryData.cc);
        setPhoneCountryCodeDigits(countryData.phoneCode);
        if (phoneNumber) {
            const phoneData = {
                raw: phoneNumber,
                formatted: phoneNumber,
                phoneCode: countryData.phoneCode,
                isValid: true
            };
            validatePhoneData(phoneData);
        }
    };

    const handlePhoneNumberBlur = (e, phoneData) => {
        setShouldCheckValidation(true);
        setPhoneNumber(phoneData.raw);
        validatePhoneData(phoneData);
    };

    const handlePhoneNumberChange = (e, phoneData) => {
        if (phoneNumber !== phoneData.raw) setPhoneNumber(phoneData.raw);
        if (shouldCheckValidation) validatePhoneData(phoneData);
    };

    const isPhoneValidFromService = () => {
        const { validationService } = phoneValidation;
        return validationService && validationService.success
            ? validationService.isValid
            : undefined;
    };

    const getErrorMessage = () => {
        const errorFromService = isPhoneValidFromService() !== false
            ? undefined
            : phoneInvalidText;
        const errorMessage = phoneValidation.error
            ? phoneValidation.error
            : errorFromService;
        return shouldCheckValidation ? errorMessage : '';
    };

    useEffect(() => {
        if (phoneNumber.length > 0) validatePhone(`+${phoneCountryCodeDigits}${phoneNumber}`);
    }, [phoneNumber]);

    const phoneProps = {
        labels: {
            phoneNumber: phoneNumberLabel,
            countryCode: phoneCountryLabel
        },
        phoneNumber,
        countryCode: phoneCountryCode,
        onCountryCodeChange: handlePhoneCountryCodeChange,
        onPhoneChange: handlePhoneNumberChange,
        onPhoneBlur: handlePhoneNumberBlur,
        errorMsg: getErrorMessage(),
        countryCodes: countryTranslations
    };

    return (
        <Phone
            {...phoneProps}
            datawdio="phone-input"
        />
    );
};

PhoneInputWrapper.propTypes = {
    setPhoneCountryCode: PropTypes.func.isRequired,
    setPhoneCountryCodeDigits: PropTypes.func.isRequired,
    validatePhone: PropTypes.func.isRequired,
    setPhoneNumber: PropTypes.func.isRequired,
    setPhoneValidation: PropTypes.func.isRequired,
    phoneInvalidText: PropTypes.string.isRequired,
    phoneValidation: PropTypes.shape({
        validationService: PropTypes.shape({
            success: PropTypes.bool,
            isValid: PropTypes.bool
        }),
        isValid: PropTypes.bool,
        error: PropTypes.string
    }).isRequired,
    phoneCountryCode: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    phoneCountryLabel: PropTypes.string.isRequired,
    phoneNumberLabel: PropTypes.string.isRequired,
    countryTranslations: PropTypes.objectOf(PropTypes.string).isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app, lead } = state;
    const {
        phoneCountryCode, phoneCountryCodeDigits, phoneNumber, phoneValidation
    } = lead;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    // This function contains the key for reading in country translations
    const countryTranslations = translations.mapCountryTranslations();

    return {
        phoneValidation,
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        phoneCountryLabel: translations.getTranslation('lyp.leadForm.phoneCountry.label'),
        phoneNumberLabel: translations.getTranslation('lyp.leadForm.phoneNumber.label'),
        phoneInvalidText: translations.getTranslation(PHONE_VALIDATION_ERROR_MESSAGE),
        countryTranslations
    };
};

/* istanbul ignore next */
export const mapDispatchToProps = dispatch => ({
    setPhoneCountryCode: code => dispatch(LeadActions.setPhoneCountryCode(code)),
    setPhoneCountryCodeDigits: code => dispatch(LeadActions.setPhoneCountryCodeDigits(code)),
    setPhoneNumber: number => dispatch(LeadActions.setPhoneNumber(number)),
    setPhoneValidation: result => dispatch(LeadActions.setPhoneValidation(result)),
    validatePhone: phoneNumber => dispatch(LeadActions.validatePhone(phoneNumber))
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInputWrapper);
